/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import { useAtomValue } from 'jotai';
import { ValidSections, pathnameUrlLanguageAtom } from '../../../../../../../../../../../../../../../../../../../../../../history';
import { useBondSAccId, useBondsBondSlug } from '../../../../../../../../../../../../../../../../../../../../../../actor/api/Services/bonds';

export const LinkedBondsElementTitleContainer = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  const language = useAtomValue(pathnameUrlLanguageAtom);
  const sAccId = useBondSAccId();
  const {
    data: slug,
  } = useBondsBondSlug();
  const css = ouiStyle.useACss({
    display: ouiStyle.Constants.DisplayProp.block,
    widthLines: 'full',
    paddingTop: 'none',
    paddingBottom: 1,
    paddingHorizontal: 3,
    color: ouiStyle.Constants.Colors.accent,
    lineFactor: 1.5,
    fontWeight: ouiStyle.Constants.FontWeightProp.bold,
    textAlign: 'center',
    hoverColor: ouiStyle.Constants.Colors.logoBlue,
  });
  if (sAccId < 0) {
    return null;
  }
  return (
    <ouiDom.A.Link
      href={`/${language}/${ValidSections.BONDS}/details/${slug ?? sAccId}`}
      css={ouiStyle.mediaQuery(css)}
    >
      {children}
    </ouiDom.A.Link>
  );
};
